// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");

var qsa = s => Array.prototype.slice.call(document.querySelectorAll(s));
var reflow = () => document.body.offsetWidth;

var byName = {};
window.appData.forEach(row => byName[row.name] = row);

var controls = document.querySelector(".controls");
var results = document.querySelector(".results");
var showcase = document.querySelector(".showcase");
var detailTemplate = require("./lib/dot").compile(require("./_details.html"));

var transition = null;

var setDetails = function(app) {
  showcase.classList.add("enter")
  showcase.innerHTML = detailTemplate(app);
  reflow();
  // showcase.classList.add("transition");
  showcase.classList.remove("enter");
  // if (transition) clearTimeout(transition);
  // transition = setTimeout(() => showcase.classList.remove("transition"), 1000);
};

var updateFilter = function() {

  //gather requirements
  var modes = qsa(".transport-modes input:checked").map(s => s.value);
  var stepByStep = !!controls.querySelector("#step-by-step").checked;
  var misc = controls.querySelector(".misc select").value;

  //filter app list
  var apps = window.appData.filter(function(item) {
    return modes.every(m => item.modes.indexOf(m) > -1);
  });
  if (stepByStep) apps = apps.filter(a => a.step_by_step);

  var prioritized = apps.filter(a => a.priorities.indexOf(misc) > -1).map(a => a.name);

  apps = apps.map(a => a.name);

  for (var name in byName) {
    var element = controls.querySelector(`[data-name="${name}"]`);
    if (apps.indexOf(name) == -1) {
      element.classList.add("disabled");  
    } else {
      element.classList.remove("disabled");
    }
    
    if (prioritized.indexOf(name) > -1) {
      element.classList.add("bonus");
    } else {
      element.classList.remove("bonus");
    }
  }

};

qsa(".recommendation input, .recommendation select").forEach(s => s.addEventListener("change", updateFilter));
updateFilter();

var matches = document.body.matches ? "matches" : "msMatchesSelector";

var closest = function(element, selector) {
  while (element !== document.body && !element[matches](selector)) {
    element = element.parentElement;
  }
  return element == document.body ? null : element;
}

var onClick = function(e) {
  if (e.target.classList.contains("selected")) return;
  var button = closest(e.target, ".browse-app");
  var name = button.getAttribute("data-name");
  var selected = controls.querySelector(".selected")
  if (selected) selected.classList.remove("selected");
  button.classList.add("selected");
  var app = byName[name];
  setDetails(app);
};

qsa(".controls .browse-app").forEach(el => el.addEventListener("click", onClick));